import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OpenModalGuardService } from './services/open-modal-guard/open-modal-guard.service';
import { FunnelGuardService } from './services/funnel-guard/funnel-guard.service';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { DebtorGuardService } from './services/debtor-guard/debtor-guard.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'mediamigos',
    loadChildren: () => import('./pages/mediamigos/mediamigos.module').then(m => m.MediamigosModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'servicio/:serviceId',
    loadChildren: () => import('./pages/services/service-quotation/service-quotation.module').then(m => m.ServiceQuotationPageModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService, FunnelGuardService]
  },
  {
    path: 'telemedicina',
    loadChildren: () => import('./pages/telemedicina/telemedicina.module').then(m => m.TelemedicinaPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'ventas-telemedicina',
    loadChildren: () => import('./pages/ventas-telemedicina/ventas-telemedicina.module').then(m => m.VentasTelemedicinaPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'funnel-tramites',
    loadChildren: () => import('./pages/tramites/funnel/funnel.module').then(m => m.FunnelPageModule),
    canActivate: [AuthGuardService, DebtorGuardService],
    canDeactivate: [OpenModalGuardService, FunnelGuardService]
  },
  {
     path: 'funnel-acompañamientos',
     loadChildren: () => import('./pages/acompanamiento/funnel/funnel.module').then(m => m.FunnelPageModule),
     canActivate: [AuthGuardService, DebtorGuardService],
     canDeactivate: [OpenModalGuardService, FunnelGuardService]
  },
  {
    path: 'planes-reclamar-medicamentos',
    loadChildren: () => import('./pages/funnel-planes/funnel-planes.module').then(m => m.FunnelPlanesPageModule),
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'mediagenda',
    loadChildren: () => import('./pages/services/services.module').then(m => m.ServicesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'medi-agenda/:service',
    loadChildren: () => import('./pages/services/service-detail/service-detail.module').then(m => m.ServiceDetailPageModule),
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'perfil',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'billetera',
    loadChildren: () => import('./pages/wallets/wallets.module').then(m => m.WalletsPageModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'pago-exitoso',
    loadChildren: () => import('./pages/wallets/wallets.module').then(m => m.WalletsPageModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'beneficiarios',
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersPageModule),
    canActivate: [AuthGuardService],
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule),
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportPageModule),
    canDeactivate: [OpenModalGuardService]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
